module.exports = __webpack_public_path__ + "img/favorites-list-empty-list-light.71445bd6.svg";